export default function Icon4() {
    return (
        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_6182_12177" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="30">
                <path d="M30.9277 0H0.927734V30H30.9277V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_6182_12177)">
                <path
                    d="M10.9277 13.125L5.92773 8.125H25.9277L21.5527 13.125M10.9277 13.125H21.5527M10.9277 13.125L13.4277 5H19.0527L21.5527 13.125M10.9277 13.125L10.0349 16.25M21.5527 13.125L22.4456 16.25M7.17773 26.25L7.92316 23.641M25.3027 26.25L24.5573 23.641M10.0349 16.25L24.5573 23.641M10.0349 16.25L7.92316 23.641M24.5573 23.641L22.4456 16.25M22.4456 16.25L7.92316 23.641"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
